import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconFileOpen(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M1.5 0.5H6.5L10.5 4.5V11.5H1.5V0.5Z" fill="#F5F5F5" />
      <path d="M6.5 0.5H1.5V11.5H10.5V4.5M6.5 0.5L10.5 4.5M6.5 0.5V4.5H10.5" stroke="currentColor" />
    </SVGIcon>
  );
}
